import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/background.png";
import MTCGame from "../../components/MTCGame";
import MTCCalculator from "../../components/MTCCalculator";
import { Button } from "../../../../globals/components/button";
import { navigate } from "@reach/router";
import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";
import { Container } from "@material-ui/core";
import Checkbox from "../../../../globals/components/Checkbox";

//GLOBALS
var generatedQuestions = false;
var qNum = 0;
var questionMode = true;
var modeText = "ANSWER";
//

//DEBUG STUFF

function Skip() {
  qNum = 24;
}
//DEBUG STUFF

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function getAnswer(calculation) {
  return 1;
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
  return 0;
}


function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds) {
      break;
    }
  }
}



function CreateUniqueQuestion(listOfQuestions) {
  var number1;
  var number2;
  var answer;
  number1 = Math.floor(Math.random() * 11) + 2;
  number2 = Math.floor(Math.random() * 11) + 2;
  answer = number1 * number2;

  var duplicate = false;

  for (var i = 0; i < listOfQuestions.length; i++) {
    //console.log("comparing " + listOfQuestions[i].answer + " with " + answer)
    if (listOfQuestions[i].answer == answer) {
      //console.log("found duplicate")
      duplicate = true;
      break;
    }
  }
  var questionObj = {
    topic_id: "MTC" + number1,
    number1: number1,
    number2: number2,
    answer: answer,
  };

  if (duplicate)
    return CreateUniqueQuestion(listOfQuestions);
  else {
    //console.log(questionObj);
    return questionObj;
  }
}

var questions;
var topics

var access = "";


export default function Rating({ ...props }) {

  const { state: authState } = useAuth();
  const [htype, setHtype] = useState(props.htype ? props.htype : "");
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [timer, setRemainingTime] = useState(
    props.timer ? props.timer : 6
  );
  const [submitted, setSubmitted] = useState(false);
  const [qAnswers, setQAnswers] = useState([]);
  const [options, setOptions] = useState(props.options ? props.options : "");
  const[realoptions, setRealOptions] = useState([]);
  //const [questions, setQuestions] = useState([]);
  //const examples = props.gameCalculations.map(calc =>
  //  calc.example_question.split(" ")
  //);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [canSubmit, setCanSubmit] = useState(false);

  const [displayValue, setDisplayValue] = useState("");
  //ACCESSABILITY
  const [optionsMenu, setOptionsMenu] = useState(true);
  const [optionsColour, setOptionsColour] = useState("black");
  const [obgcolor, setBgColor] = useState("white");
  const [otextcolor, setTextColor] = useState("black");
  const [otextcolor2, setTextColor2] = useState("white");

  const [optionsFontSize, setOptionsFontSize] = useState("100px");
  var colourTypes = ["black","yellow","blackblue","blackpeach","bluecream"];


  topics = props.topics;
  //console.log(topics);
  //console.log(props);

  useEffect(() => {
    console.log(props.access);
    console.log(options);
    setRealOptions(options.split("|"));
    console.log("do this once");
    console.log(qNum);
    generatedQuestions = false;

      if (generatedQuestions == false) {
        console.log("I am generating = " + generatedQuestions)
        if (htype == ""){
          questions = CreateMTCQuestions()
          //console.log(questions)
          qNum = 0;
          console.log("I ran");
        }else{
          questions = CreateFixedMTCQuestions()
          //console.log(questions)
          qNum = 0;
          console.log("I ran");
        }
      }
  }, []);


  //console.log(questions);

  //create questions
  //25 questions
  //create answers

  function CreateFixedMTCQuestions(){
    access = props.access;
    var year3AutumnTerm1 = "2 x 3,5 x 3,1 x 10,6 x 3,2 x 5 ,12 x 8,12 x 10,3 x 10,1 x 4,6 x 6,8 x 2,9 x 6,7 x 8,10 x 4,5 x 8,9 x 2,3 x 5,2 x 8 ,8 x 4,2 x 5,7 x 2,12 x 4,11 x 8,4 x 6,12 x 6";
	  var year3AutumnTerm2="2 x 2,7 x 10,2 x 3,1 x 4,4 x 10,5 x 5,3 x 6 ,5 x 2,2 x 8,8 x 8,8 x 5,7 x 8,11 x 6,12 x 2,1 x 3,6 x 6,12 x 10,3 x 4,12 x 8,9 x 4,12 x 5,2 x 6,9 x 8,6 x 4,10 x 3";
	  var year46AutumnTerm1 = "6 x 12,12 x 10,10 x 4,11 x 11,8 x 6 ,6 x 11,12 x 4,11 x 12,9 x 9 ,5 x 4,8 x 5,2 x 10,7 x 9 ,12 x 9 ,3 x 7,4 x 9,7 x 3,9 x 6 ,8 x 2,3 x 10 ,4 x 6,5 x 8 ,7 x 11,6 x 2,10 x 5";
    var year46AutumnTerm2="10 x 10,3 x 4,12 x 2,2 x 6,5 x 12,9 x 4,3 x 8,6 x 7,9 x 11,6 x 3,1 x 8,12 x 6,3 x 12,7 x 10,4 x 9,7 x 9,11 x 5,8 x 2,7 x 11,7 x 7,12 x 3,11 x 4,5 x 5,9 x 9,12 x 8";
    var year3SpringTerm1="5 x 10,11 x 6,4 x 10,12 x 5,1 x 3,2 x 2,8 x 4,6 x 8,3 x 5,1 x 10,2 x 6,5 x 2,7 x 8,9 x 2,12 x 3,10 x 5,6 x 6,9 x 6,3 x 3,2 x 4,5 x 8,7 x 4,12 x 4,10 x 8,3 x 8";
    var year46SpringTerm1="2 x 9 ,6 x 3,9 x 3,5 x 12,5 x 2,8 x 3,4 x 4,9 x 4,3 x 2,11 x 11,7 x 9 ,8 x 11,11 x 10,3 x 5,4 x 7,12 x 6,12 x 9 ,9 x 8,8 x 10,6 x 6,6 x 8 ,12 x 12,7 x 11,7 x 7 ,10 x 9";
    var year3SpringTerm2="2 x 2 ,1 x 10,2 x 6,4 x 4,3 x 3,7 x 8,7 x 3,8 x 2 ,4 x 6,9 x 8,7 x 5,3 x 8,12 x 4,12 x 6,6 x 5,9 x 5,9 x 4,5 x 4,11 x 2,6 x 10,2 x 6 ,12 x 8,8 x 6,10 x 3,5 x 10";
    var year46SpringTerm2="12 x 5,11 x 4,8 x 11,6 x 12,9 x 9 ,9 x 6 ,6 x 11,3 x 2,3 x 9 ,8 x 2,7 x 3,9 x 4,2 x 6,7 x 9 ,5 x 9,7 x 10,12 x 7,4 x 12,6 x 3,12 x 3,11 x 7 ,10 x 11,4 x 2,5 x 8 ,8 x 6";
    var year3SummerTerm1="1 x 6 ,12 x 3,2 x 3,7 x 4,6 x 2,5 x 8 ,1 x 2,4 x 10,12 x 2,2 x 4,3 x 4,8 x 8 ,9 x 5,2 x 6,3 x 10,10 x 6,9 x 4,5 x 6 ,12 x 5,7 x 3,6 x 8 ,11 x 10,8 x 4,2 x 5 ,12 x 8";
    var year46SummerTerm1="6 x 6 ,12 x 12,7 x 11,7 x 9 ,6 x 2,5 x 8 ,9 x 12,4 x 11,12 x 2,8 x 3,3 x 4,8 x 8 ,9 x 5,4 x 6,3 x 9,10 x 6,9 x 4,5 x 6 ,11 x 7,7 x 4,6 x 8 ,11 x 10,8 x 9,2 x 7 ,12 x 8";
    var year3SummerTerm2="1 x 6,12 x 8,3 x 10,2 x 8,12 x 2,2 x 5,12 x 4,5 x 4,1 x 8,5 x 5,7 x 10,9 x 4,6 x 3,4 x 2,2 x 4,12 x 10,9 x 6,10 x 2,7 x 3,11 x 5,6 x 6,8 x 3,3 x 4,2 x 6,8 x 8";
    var year46SummerTerm2="12 x 7,12 x 8,3 x 10,6 x 9 ,12 x 2,2 x 5,8 x 4,5 x 4,9 x 9 ,5 x 7,7 x 10,9 x 6,6 x 11,4 x 7 ,7 x 8,11 x 12,9 x 12,10 x 2,7 x 11,11 x 5,6 x 12,8 x 3,3 x 4,4 x 12,8 x 8";
    //MTC DISAPPLY
    var mtcDisapplyAssessment1 = "4 x 2,5 x 5,5 x 10,10 x 2,8 x 5,6 x 10,8 x 3,12 x 2,2 x 5,10 x 10,9 x 2,3 x 5,7 x 10,11 x 3,8 x 2,10 x 5,3 x 10,6 x 2,9 x 5,2 x 10,6 x 3,7 x 2,7 x 5,4 x 10,5 x 2";
	  var mtcDisapplyAssessment2 = "12 x 2,3 x 5,4 x 10,6 x 2,2 x 5,3 x 10,2 x 3,8 x 2,7 x 5,7 x 10,5 x 2,6 x 5,5 x 10,4 x 3,11 x 2,5 x 5,8 x 10,3 x 2,4 x 5,11 x 10,7 x 3,7 x 2,9 x 5,2 x 10,4 x 2";
	  var mtcDisapplyAssessment3 = "5 x 2,11 x 5,9 x 10,9 x 2,5 x 5,3 x 10,9 x 3,8 x 2,10 x 5,6 x 10,11 x 2,9 x 5,2 x 10,12 x 3,4 x 2,8 x 5,10 x 10,10 x 2,6 x 5,11 x 10,11 x 3,3 x 2,7 x 5,5 x 10,2 x 2";
	  var mtcDisapplyAssessment4 = "2 x 2,5 x 5,4 x 10,10 x 2,4 x 5,8 x 10,2 x 3,3 x 2,3 x 5,3 x 10,7 x 2,7 x 5,9 x 10,9 x 3,5 x 2,9 x 5,11 x 10,12 x 2,6 x 5,7 x 10,6 x 3,6 x 2,8 x 5,6 x 10,8 x 2";
    //new assessments 2026
    var year3NewAutumnTerm1 = "2 x 5,10 x 6,0 x 10,10 x 8,10 x 7,5 x 4,10 x 11,2 x 11,10 x 3,2 x 10,10 x 10,2 x 4,5 x 6,5 x 12,2 x 3,5 x 7,5 x 9,2 x 7,2 x 2,5 x 8,5 x 5,5 x 10,10 x 12,2 x 8,10 x 9";
	  var year3NewAutumnTerm2 = "2 x 2,2 x 8,10 x 11,5 x 4,5 x 3,2 x 6,0 x 8,10 x 10,10 x 4,2 x 7,5 x 7,10 x 5,5 x 12,2 x 5,5 x 10,2 x 10,10 x 10,2 x 3,5 x 6,10 x 11,10 x 9,5 x 7,5 x 9,10 x 12,2 x 8";
	  var year3NewSpringTerm1 = "3 x 11,3 x 2,3 x 7,6 x 6,5 x 7,5 x 3,2 x 2,2 x 5,3 x 5,6 x 12,6 x 10,5 x 8,10 x 11,6 x 4,10 x 9,2 x 4,3 x 8,10 x 8,10 x 5,5 x 6,2 x 10,10 x 12,5 x 9,6 x 3,2 x 6";
	  var year3NewSpringTerm2 = "5 x 4,10 x 7,5 x 8,10 x 2,5 x 12,10 x 9,6 x 5,2 x 8,6 x 4,2 x 10,10 x 6,3 x 2,5 x 12,3 x 9,2 x 8,3 x 6,5 x 3,6 x 3,2 x 11,2 x 6,6 x 7,10 x 11,3 x 10,6 x 5,3 x 5";
	  var year3NewSummerTerm1 = "2 x 2,10 x 5,6 x 9,8 x 11,2 x 10,10 x 4,4 x 11,6 x 8,0 x 4,2 x 7,10 x 8,2 x 8,3 x 12,5 x 5,4 x 3,10 x 10,5 x 5,6 x 6,8 x 7,5 x 12,3 x 2,3 x 6,4 x 3,5 x 9,8 x 6";
	  var year3NewSummerTerm2 = "2 x 10,5 x 6,10 x 2,5 x 5,2 x 3,3 x 3,10 x 2,2 x 10,3 x 5,4 x 6,4 x 2,0 x 5,8 x 6,4 x 5,3 x 10,6 x 3,8 x 2,6 x 3,10 x 6,5 x 6,6 x 2,5 x 10,10 x 3,8 x 10,2 x 5";

    var questionList = null;

    if (htype == "mtcfixed|3|spring|1"){
			questionList = year3SpringTerm1;
		}
		if (htype == "mtcfixed|4-6|spring|1"){
			questionList = year46SpringTerm1;
		}
		if (htype == "mtcfixed|3|spring|2"){
			questionList = year3SpringTerm2;
		}
		if (htype == "mtcfixed|4-6|spring|2"){
			questionList = year46SpringTerm2;
		}

		if (htype == "mtcfixed|3|summer|1"){
			questionList = year3SummerTerm1;
		}
		if (htype == "mtcfixed|4-6|summer|1"){
			questionList = year46SummerTerm1;
		}
		if (htype == "mtcfixed|3|summer|2"){
			questionList = year3SummerTerm2;
		}
		if (htype == "mtcfixed|4-6|summer|2"){
			questionList = year46SummerTerm2;
		}

		if (htype == "mtcfixed|3|autumn|1"){
			questionList = year3AutumnTerm1;
		}
		if (htype == "mtcfixed|4-6|autumn|1"){
			questionList = year46AutumnTerm1;
		}
		if (htype == "mtcfixed|3|autumn|2"){
			questionList = year3AutumnTerm2;
		}
		if (htype == "mtcfixed|4-6|autumn|2"){
			questionList = year46AutumnTerm2;
		}
    if (htype== "mtcfixed|disapply|1"){
			questionList = mtcDisapplyAssessment1;
		}
		if (htype == "mtcfixed|disapply|2"){
			questionList = mtcDisapplyAssessment2;
		}
		if (htype == "mtcfixed|disapply|3"){
			questionList = mtcDisapplyAssessment3;
		}
		if (htype == "mtcfixed|disapply|4"){
			questionList = mtcDisapplyAssessment4;
		}
    if (htype == "mtcfixed|3new|autumn|1") { questionList = year3NewAutumnTerm1; }
    if (htype == "mtcfixed|3new|autumn|2") { questionList = year3NewAutumnTerm2; }
    if (htype == "mtcfixed|3new|spring|1") { questionList = year3NewSpringTerm1; }
    if (htype == "mtcfixed|3new|spring|2") { questionList = year3NewSpringTerm2; }
    if (htype == "mtcfixed|3new|summer|1") { questionList = year3NewSummerTerm1; }
    if (htype == "mtcfixed|3new|summer|2") { questionList = year3NewSummerTerm2; }


    //convert the list into actual questions
		questionList = questionList.replace(" ", "");
		var parsedQuestions = questionList.split(",");

    var qs = [];

    for (let i = 0; i < parsedQuestions.length; i++) {
			var splitquestion = parsedQuestions[i].split("x");
        let number1 = parseInt(splitquestion[0]);
        let number2 = parseInt(splitquestion[1]);
        var answer
        answer = number1 * number2;
        var questionObj = {
          topic_id: "MTC" + number1,
          number1: number1,
          number2: number2,
          answer: answer,
        };
        qs.push(questionObj)
      }
      //shuffleArray(qs);
      generatedQuestions = true;
      return qs;
  }

  function CreateMTCQuestionsLikeTable(){
    var minimum = [0,1,1,1,2,2,2,2,0,1,2];
    var maximum = [2,3,3,3,4,4,4,4,2,3,4];
    var numbers = [2,3,4,5,6,7,8,9,10,11,12];
    var qs = [];
    //add 2 times questions
    //do minimum first

    for (let i = 0; i < minimum.length; i++) {
      const generateAmount = minimum[i];
      for (let x = 0; x < generateAmount; x++) {
        let number1 = numbers[i];
        let number2 = GenerateRandom(2,12);
        let answer = number1 * number2;
        var questionObj = {
          topic_id: "MTC" + number1,
          number1: number1,
          number2: number2,
          answer: answer,
        };
        qs.push(questionObj)
      }
      maximum[i] -= generateAmount;
    }
    console.log("MINIMUM GEN");
    console.log(qs);
    while (qs.length < 25){
      var num = GenerateRandom(0,maximum.length-1);
      while (maximum[num] == 0){
        num = GenerateRandom(0,maximum.length-1);
      }

      let number1 = numbers[num];
      let number2 = GenerateRandom(2,12);
        let answer = number1 * number2;
        var questionObj = {
          topic_id: "MTC" + number1,
          number1: number1,
          number2: number2,
          answer: answer,
        };
        qs.push(questionObj)
        maximum[num] -= 1;
    }
    console.log("GENERATED");
    console.log(qs);
    return qs;
  }

  function CreateMTCQuestions() {
    var qs = [];
  
    if (props != undefined){
      console.log(props);
      if (props.homework_id == undefined){
        
        console.log("TOPICS = ");
        console.log(topics);
        access = props.access;
        //create enough questions with the topics selected
        if (topics.length == 11){
          //GENERATE ACCORDING TO THE TABLE
          qs = CreateMTCQuestionsLikeTable();
          generatedQuestions = true;
        }else{
          while (qs.length < 25){
            var number1;
            var number2;
            var answer;
            number1 = topics[GenerateRandom(0,topics.length-1)];
            number2 = GenerateRandom(2,12);
            answer = number1 * number2;
            var questionObj = {
              topic_id: "MTC" + number1,
              number1: number1,
              number2: number2,
              answer: answer,
            };
            qs.push(questionObj)
          }
        }
        generatedQuestions = true;
    }else{
      console.log(props);
      access = props.access;
      console.log(access);
      topics = props.topics;
      for (let i = 0; i < topics.length; i++) {
        topics[i] = topics[i].replace("MTC", "");
      }
      
      if (topics.length == 11){
        //GENERATE ACCORDING TO THE TABLE
        qs = CreateMTCQuestionsLikeTable();
        generatedQuestions = true;
      }else{
        while (qs.length < 25){
          var number1;
          var number2;
          var answer;
          number1 = topics[GenerateRandom(0,topics.length-1)];
          number2 = GenerateRandom(2,12);
          answer = number1 * number2;
          var questionObj = {
            topic_id: "MTC" + number1,
            number1: number1,
            number2: number2,
            answer: answer,
          };
          qs.push(questionObj)
        }
      }
      shuffleArray(qs);
      generatedQuestions = true;
    }
  }
    return qs;
  }

  function TimerCheckResult(value) {
    console.log(value);
    var isCorrect = true;
    var dupeQuestion = {
      answer: currentQuestion.answer,
      number1: currentQuestion.number1,
      number2: currentQuestion.number2,
      topic_id: currentQuestion.topic_id,
      num_asked:  0,
      num_correct:  0,
    };
    if (parseInt(currentQuestion.answer) === parseInt(value)) {
      dupeQuestion.num_correct = 1;
      setCorrectQuestions([...correctQuestions, dupeQuestion]);
      setScore(score + 1);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }
    } //incorrect answer
    else {
      isCorrect = false;
      dupeQuestion.num_correct = 0;
      setIncorrectQuestions([...incorrectQuestions, dupeQuestion]);
      if (combo === 0 && score >= 10) {
        //setScore(score - 1);
      } else {
        setCombo(0);
      }

      let result = {
        topic_id: currentQuestion.topic_id,
        question: currentQuestion.number1 + " x " + currentQuestion.number2,
        correct: currentQuestion.answer,
        incorrect: value
      };

      setFeedback([...feedback, result]);
    }

    let qa = {
      question: currentQuestion.number1 + " x " + currentQuestion.number2,
      correct: isCorrect,
      answer: value
    }
    setQAnswers([...qAnswers, qa]);

    console.log(qAnswers);
    console.log("question " + qNum);
    console.log(access);
    if (access == "" || access == "clash"){
      setRemainingTime(3);
    }else{
      setRemainingTime(999999);
    }
    if (realoptions.includes("access")){
      setRemainingTime(999999);
    }
    questionMode = false;
    modeText = "WAIT";
  }

  async function timeoutDisplay(value)
  {
    console.log("display value:");
    console.log(value);
    setDisplayValue(value);
  }



  
  async function checkResult(value, callback) {
    setCanSubmit(false);
    var isCorrect = true;
    console.log(value);
    console.log("question " + qNum);
    var dupeQuestion = {
      answer: currentQuestion.answer,
      number1: currentQuestion.number1,
      number2: currentQuestion.number2,
      topic_id: currentQuestion.topic_id,
      num_asked: 0,
      num_correct: 0,
    };

    if (value) {
      //correct answer
      if (parseInt(currentQuestion.answer) === parseInt(value)) {
        dupeQuestion.num_correct = 1;
        setCorrectQuestions([...correctQuestions, dupeQuestion]);
        setScore(score + 1);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
      } //uincorrect answer
      else {
        isCorrect = false;
        dupeQuestion.num_correct = 0;
        setIncorrectQuestions([...incorrectQuestions, dupeQuestion]);
        if (combo === 0 && score >= 10) {
          //setScore(score - 1);
        } else {
          setCombo(0);
        }

        let result = {
          topic_id: currentQuestion.topic_id,
          question: currentQuestion.number1 + " x " + currentQuestion.number2,
          correct: currentQuestion.answer,
          incorrect: value
        };

        setFeedback([...feedback, result]);
      }

      let qa = {
        question: currentQuestion.number1 + " x " + currentQuestion.number2,
        correct: isCorrect,
        answer: value
      }
      setQAnswers([...qAnswers, qa]);
      console.log(qAnswers);
      
      console.log("question " + qNum);
      qNum = qNum + 1;
      if (access == "" || access == "clash"){
        setRemainingTime(3);
      }else{
        setRemainingTime(999999);
      }
      if (realoptions.includes("access")){
        setRemainingTime(999999);
      }
      questionMode = false;
      modeText = "WAIT";
    }
  }

  function NextQuestion() {
    //check props.questionsanswered and set props.questionsanswered. need to pass this variable to MTCGame so it can check if you have finished the game
      setCanSubmit(true);
      setDisplayValue("");
      setCurrentQuestion(
      questions[qNum]
    );
  }


  function SubmitTopics() {
    if (submitted == true) {
      return
    }
    setSubmitted(true);
    console.log(correctQuestions);
    console.log(incorrectQuestions);

    let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correctQuestions.length + incorrectQuestions.length)).toFixed(2);

    let correctByTopics = correctQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});
    let incorrectByTopics = incorrectQuestions.reduce((byTopics, question) => {
      byTopics[question.topic_id] = byTopics[question.topic_id] || [];
      byTopics[question.topic_id].push(question);
      return byTopics;
    }, {});

    window.correctByTopics = correctByTopics;
    window.incorrectByTopics = incorrectByTopics;
    console.log(correctByTopics);
    console.log(incorrectByTopics);

    let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
      let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
      let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
      console.log("topicID");
      console.log(topic_id);
      let tempTopicID = (topic_id);
      let tempAverageAnswerTime = parseFloat(average_ans_time);
      return {
        //topic_id: tempTopicID,
        topic_key: topic_id,
        num_correct,
        num_asked: num_correct + num_incorrect,
        average_ans_time: tempAverageAnswerTime
      }
    });
    console.log(topicstats);

    //check if timer is 6 and all topics in, then set as rating instead of practice
    let mode = "Practice";
    if (props.timer == 6 && props.topics.length == 11){
      mode = "Rating";
    }

    axios({
      url: `${process.env.REACT_APP_API}/submissions`,
      method: "post",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
        "homework_id": props.homework_id,
        "topicstats": topicstats,
        "game_id": 22, //ID equals galaxy id
        "platform": mode+"|WEB" + "|" + process.env.REACT_APP_VERSION_NO,
        "questionsAnswered": JSON.stringify(qAnswers)
      }
    });
  }

  // set the first question
  useEffect(() => {
    console.log("first question");
    setCanSubmit(true);
    setCurrentQuestion(questions[qNum]);
  }, []);

  useEffect(() => {
    if (qNum < 25) {
      if (timer > 0) {
        var timerID = setTimeout(() => decrementTimer(), 1000);
        return () => {
          clearTimeout(timerID);
        };
      } else {
        if (questionMode) {
          //if question mode then does the 3 second timer
          qNum = qNum + 1;
          if (access == "" || access == "clash"){
            setRemainingTime(3);
          }else{
            setRemainingTime(999999);
          }
          if (realoptions.includes("access")){
            setRemainingTime(999999);
          }
          //also submits answer
          TimerCheckResult(displayValue);
          modeText = "WAIT";
          questionMode = false;
        } else {
          NextQuestion();
          setRemainingTime(props.timer);
          modeText = "ANSWER";
          questionMode = true;
        }
        //next question
      }
    } else {
      //var timerID = setTimeout(() => decrementTimer(), 1000);
      console.log("endgame");
      let submitTopicsTimer = setTimeout(() => {
        SubmitTopics();
      }, 1000); // Delay submission by 1.5 seconds to ensure state updates
      return () => {
        clearTimeout(timerID);
      };
    }
  }, [timer]);

  function decrementTimer() {
    if (optionsMenu == false){
      setRemainingTime(timer - 1);
    }else{
      setRemainingTime(timer + 1);
    }
  }

  function NextQuestionAccess(){
    console.log("NEXT QUESTION ACCESS");
    NextQuestion();
    setRemainingTime(props.timer);
    modeText = "ANSWER";
    questionMode = true;
  }

  function AreYouSureBack(){

    if (props.homework_id != null && props.homework_id != ""){
        if (window.confirm("If you leave the task part done it will show as incomplete and you will have to start again.")){
            EarlySubmission();
        }
    }else{
        if (window.confirm("are you sure you want to exit?")){
            EarlySubmission();
        }
    }
}

  function EarlySubmission(){
        //UpdateProgress(props);
          if (submitted == true) {
            return
          }
          setSubmitted(true);
          console.log(correctQuestions);
          console.log(incorrectQuestions);
      
          let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correctQuestions.length + incorrectQuestions.length)).toFixed(2);
      
          let correctByTopics = correctQuestions.reduce((byTopics, question) => {
            byTopics[question.topic_id] = byTopics[question.topic_id] || [];
            byTopics[question.topic_id].push(question);
            return byTopics;
          }, {});
          let incorrectByTopics = incorrectQuestions.reduce((byTopics, question) => {
            byTopics[question.topic_id] = byTopics[question.topic_id] || [];
            byTopics[question.topic_id].push(question);
            return byTopics;
          }, {});
      
          window.correctByTopics = correctByTopics;
          window.incorrectByTopics = incorrectByTopics;
          console.log(correctByTopics);
          console.log(incorrectByTopics);
      
          let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
            let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
            let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
            console.log("topicID");
            console.log(topic_id);
            let tempTopicID = (topic_id);
            let tempAverageAnswerTime = parseFloat(average_ans_time);
            return {
              //topic_id: tempTopicID,
              topic_key: topic_id,
              num_correct,
              num_asked: num_correct + num_incorrect,
              average_ans_time: tempAverageAnswerTime
            }
          });
          console.log(topicstats);
      
          axios({
            url: `${process.env.REACT_APP_API}/submissions`,
            method: "post",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": `Bearer ${authState.access_token}`
            },
            data: {
              "homework_id": props.homework_id,
              "topicstats": topicstats,
              "game_id": 22, //ID equals galaxy id
              "platform": "Practice|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO + "|incomplete",
              "questionsAnswered": JSON.stringify(qAnswers)
            }
          });
        //then go back
        console.log("restart me")
        setFeedback([]);
        setCombo(0);
        setScore(0);
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        setRemainingTime(9);
        modeText = "ANSWER";
        questionMode = true;
        qNum = 0;
        generatedQuestions = false;
        navigate("/games/22");
    }

    function QuitGame(){
       console.log("restart me")
      setFeedback([]);
      setCombo(0);
      setScore(0);
      setCorrectQuestions([...correctQuestions, currentQuestion]);
      setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
      setRemainingTime(9);
      modeText = "ANSWER";
      questionMode = true;
      qNum = 0;
      generatedQuestions = false;
      navigate("/games/22");
    }

  function GoBack() {
    if (submitted == true){
      QuitGame();
    }else{
      AreYouSureBack();
    }
    }
    

  function ReturnTimer(){
    if (timer < 999){
      return (<div>Time Left: <b>{timer}</b> </div> );
    }
    else{
      return "";
    }
  }

  function CanISubmit(){
    //console.log(realoptions);
    if (realoptions.includes("disable_submit") && timer < 999){
      return false;
    }else{
      return canSubmit;
    }
  }

  function onOptionSelect(option){
    setOptionsColour(option);
    //check the option
    if (option == "black"){
        setBgColor("white");
        setTextColor("black");
        setTextColor2("white");//the text for buttons
    }
    if (option == "yellow"){
        setBgColor("black");
        setTextColor("yellow");
        setTextColor2("black");//the text for buttons
    }
    if (option == "blackblue"){
        setBgColor("#92A5ED");
        setTextColor("black");
        setTextColor2("#92A5ED");//the text for buttons
    }
    if (option == "blackpeach"){
      setBgColor("#DEC4A5");
      setTextColor("black");
      setTextColor2("#DEC4A5");//the text for buttons
  }
  if (option == "bluecream"){
    setBgColor("#EAE0BE");
    setTextColor("#0F168A");
    setTextColor2("#EAE0BE");//the text for buttons
}
    
  }

  function StartGame(){
    setRemainingTime(props.timer ? props.timer : 6);
    setOptionsMenu(false);
  }

  
  if (optionsMenu == true){
    return (
      <Container>
        <h1 style={{fontSize: "50px"}}>Choose colour of page</h1>
            <Checkbox 
              label={"Black on White"}
              labelcolor="black"
              labelbackground="white"
              onChange={e => {
                  onOptionSelect("black");
              }}
              checked={
                optionsColour == "black"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Yellow on Black"}
              labelbackground="black"
              labelcolor="yellow"
              onChange={e => {
                  onOptionSelect("yellow");
              }}
              checked={
                optionsColour == "yellow"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Black on Blue"}
              onChange={e => {
                  onOptionSelect("blackblue");
              }}
              labelbackground="#92A5ED"
              labelcolor="black"
              checked={
                optionsColour == "blackblue"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Black on Peach"}
              onChange={e => {
                  onOptionSelect("blackpeach");
              }}
              labelbackground="#DEC4A5"
              labelcolor="black"
              checked={
                optionsColour == "blackpeach"
                  ? true
                  : false
                  }></Checkbox><br/>

<Checkbox 
              label={"Blue on Cream"}
              onChange={e => {
                  onOptionSelect("bluecream");
              }}
              labelbackground="#EAE0BE"
              labelcolor="#0F168A"
              checked={
                optionsColour == "bluecream"
                  ? true
                  : false
                  }></Checkbox>
                  <br/>

                  <LevelButton
                   onClick={() => StartGame()}>

                    Start
                  </LevelButton>


            
      </Container>
    );
  }else{
  return (

    <MTCGame
      optionsColour={optionsColour}
      bgcolor={obgcolor}
      noexit={props.noexit}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => {
        GoBack();
      }}
      quitGame={() => {
        QuitGame();
      }}
      defaultTimer={props.timer}
      restart={() => {
        console.log("restart me")
        setFeedback([]);
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
        setRemainingTime(props.timer);
        modeText = "ANSWER";
        questionMode = true;
        qNum = 0;
        generatedQuestions = false;
        NextQuestion();
      }}
      feedback={feedback}
      questionsAnswered={qNum}
    >
      {generatedQuestions ? (
        <Body>
          {questionMode && currentQuestion != undefined ? (
            <div style={{
              position: "relative",
              right: "-20%",
            }}>
              <MTCCalculator
                textcolor={otextcolor}
                bgcolor={obgcolor}
                textcolor2={otextcolor2}

                cansubmit = {CanISubmit()}
                currentQuestion={currentQuestion}
                onSubmitted={checkResult}
                onChange={timeoutDisplay}
              />
            </div>
          ) : (<div></div>
            )}
          <div style={{
            height: "20%"
          }}>
            {modeText == "ANSWER" ? (
              <div>
                <div style={{
                  color:otextcolor,
                  fontSize: "30px", height: "20%", position: "relative",
                  right: "-220%",
                }}>{ReturnTimer()}</div>

              </div>
            ) : (
                <div style={{
                  fontSize: "50px",
                  color:otextcolor,
                  textAlign: "center"
                }}>
                  Question: {qNum + 1}

                  {realoptions.includes("access") &&
                  <div>
                  <Button style={{background: obgcolor, color:otextcolor, border:"10px solid " + otextcolor}}onClick={()=>NextQuestionAccess()}>Next Question</Button> 
                  </div>
                  }
                </div>

              )}
          </div>
        </Body>
      ) : (<div></div>)}
    </MTCGame>
  );
   }
}


const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;



const Body = styled.div`
  width: 100%;
  height: 100%;
  //background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;

const Result = styled.div`
  width: 100%;
  height: 100%;
  font-size: 5em;
  text-align: center;
  border: solid 2px #683d8c;
`;

const Combo = styled.div`
  background: #707070;
  width: 120px;
  height: 120px;
  border-radius: 75px;
  border: solid #636363 4px;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #fff;
  justify-content: center;
  font-weight: 600;
`;

